import { imageNames } from "@/src/constants/imageConstants.js";
import DiscountTag from "@/src/styled_components/DiscountTag.vue";
import {
  featureNames,
  pluralFeatureNames,
} from "@/src/constants/globalConstants";

export const billingStatusOptions = {
  PAID: "ACTIVE",
  FREE_TRIAL: "FREE_TRIAL",
  FREE_PLAN: "FREE_PLAN",
  UNLIMITED: "UNLIMITED",
};

export const billingV3StatusOptions = {
  ACTIVE: "active",
  TRIAL: "trial",
  FREE: "free",
  DELINQUENT: "delinquent",
  GRACE: "grace",
  SUSPENDED: "suspended",
  CANCELLED: "cancelled",
};

export const billingV4StatusOptions = {
  ACTIVE: "active",
  DELINQUENT: "delinquent",
  GRACE: "grace",
  SUSPENDED: "suspended",
  CANCELLED: "cancelled",
};

export const paymentStatusOptions = {
  PAYMENT_FAILED: "payment_failed",
  ACTIVE: "active",
};

export const billingVersions = {
  V0: "v0",
  V1: "v1",
  V3: "v3",
  V4: "v4",
};

export const billingStatues = {
  PAID: "PAID",
  FREE_TRIAL: "FREE_TRIAL",
  FREE_PLAN: "FREE_PLAN",
  ACTIVE: "ACTIVE",
};

export const paidStatuses = [billingStatues.PAID, billingStatues.ACTIVE];

export const perksOfUpgrading = [
  featureNames.COLD_OUTREACH,
  "B2B Lead Database",
  "CRM",
  "AI Voice Agents",
  "AI Dialer",
  "Segmentation",
  "Meetings",
  "Marketing Agents",
  featureNames.SEQUENCES + "s",
  "Journey Orchestration",
];

export const billingPacks = {
  MONTHLY: "monthly",
  QUARTERLY: "quarterly",
  SEMI_ANNUALLY: "semi_annual",
  ANNUALLY: "annual",
  TWO_YEARS: "two_year",
};

export const billedLabelMap = {
  [billingPacks.MONTHLY]: "Billed Monthly",
  [billingPacks.QUARTERLY]: "Billed Quarterly",
  [billingPacks.SEMI_ANNUALLY]: "Billed Semi-Annually",
  [billingPacks.ANNUALLY]: "Billed Annually",
  [billingPacks.TWO_YEARS]: "Billed Every 2 Years",
};

export const billingPacksTextMapping = {
  [billingPacks.MONTHLY]: "month",
  [billingPacks.QUARTERLY]: "quarter",
  [billingPacks.SEMI_ANNUALLY]: "6 months",
  [billingPacks.ANNUALLY]: "annual",
  [billingPacks.TWO_YEARS]: "2 years",
};

export const billingPackTabs = [
  {
    id: billingPacks.MONTHLY,
    title: "Monthly",
  },
  {
    id: billingPacks.QUARTERLY,
    title: "Quarterly",
  },
  {
    id: billingPacks.SEMI_ANNUALLY,
    title: "Semi-Annually",
  },
  {
    id: billingPacks.ANNUALLY,
    title: "Annually",
    header: DiscountTag,
  },
  {
    id: billingPacks.TWO_YEARS,
    title: "2 Years",
  },
];

export const billingTabs = [
  {
    label: "Monthly",
    value: "monthly",
    isAnnual: false,
    discount: 0,
  },
  {
    label: "Quarterly",
    value: "quarterly",
    isAnnual: false,
    discount: 10,
  },
  {
    label: "Semi-annually",
    value: "semi_annual",
    isAnnual: false,
    discount: 10,
  },
  {
    label: "Annually",
    value: "annual",
    isAnnual: true,
    discount: 25,
  },
  {
    label: "2 years",
    value: "two_year",
    isAnnual: true,
    discount: 30,
  },
];

export const billingSetupStatuses = {
  INITIATED: "initiated",
  SUCCESS: "success",
  CANCELLED: "cancelled",
};

export const freePlanFeatures = ["Access to 1 SuperAGI App"];

export const starterPlanFeatures = [
  "Access to 3 SuperAGI Apps",
  "AI-Native CRM",
  "Power Dialer",
  "Conversational Intelligence (lite)",
  "Multi-Channel AI Sequences (up to 5)",
  "Deals + Custom Properties",
  `AI SDR (Email + LinkedIn)`,
  "Marketing Campaigns",
  "Live Chat",
  "Real Time Intent Signals (20 leads/day)",
  "Email Support",
];

export const growthPlanFeatures = [
  "Access to 3 SuperAGI Apps",
  "Basic Integrations",
  "Basic Analytics",
  "Support Resolution in 72 hours",
];

export const proPlanFeatures = [
  "Access to all SuperAGI Apps",
  "Role based access control",
  "Audit Logs",
  "Advanced Integrations",
  "Advanced Analytics",
  "Onboarding Support",
  "Customer Success Manager",
  "Priority Support with <24 hours resolution time",
  "External API access (Rate Limited)",
];

export const customPlanFeatures = [
  "Everything in Business +",
  "API Access with No Rate Limiting",
  "SAML SSO",
  "User Provisioning (SCIM)",
  "Advanced Security & Controls",
  "Customization & Solutioning Support",
];

export const planNames = {
  FREE_PLAN: "Free",
  FREE_STARTER: "Starter",
  FREE_GROWTH: "Growth",
  FREE_PRO: "Pro",
  CUSTOM: "Custom",
};

export const planNameMapping = {
  Free: "Free",
  Starter: "Starter",
  Growth: "Starter",
  Pro: "Business",
  Custom: "Enterprise",
};

export const billingAccountStatus = {
  NEW: "NEW",
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  PAID: "PAID",
  FREE_TRIAL: "FREE_TRIAL",
  FREE_PLAN: "FREE_PLAN",
  UNLIMITED: "UNLIMITED",
};

export const creditConsumptionData = [
  // {
  //   action: "CRM Records",
  //   credits: "1 credit per 10 records monthly",
  //   tooltip:
  //     "Records created in CRM via direct creation in CRM, Sequences, Workflows, Leads created via Meeting router, Prospect, Webhooks",
  // },
  // { action: "Customer Success Tasks", credits: "1 credit per 10 records" },
  // { action: "Customer Support Tickets", credits: "1 credit per 10 records" },
  // { action: "Project Tasks", credits: "1 credit per 10 records" },
  // { action: "Sequence Tasks", credits: "1 credit per 10 records" },
  { action: "Enrich Phone Number", credits: "10 credits per phone number" },
  { action: "Enrich Email", credits: "1 credit per email" },
  { action: "Enrich Companies", credits: "1 credit per company" },
  { action: "Mailbox Purchase", credits: "2100 credits per mailbox per year" },
  {
    action: "Domain Cost",
    credits: "Depends on domain type (starts at 700 per domain per year)",
  },
  {
    action: "Dialer Pricing",
    credits: "Check here",
    link: "https://billing.superagi.com/call_pricing",
  },
  { action: "Email Sent", credits: "2 credits per 100 emails sent" },
  {
    action: "WhatsApp Message Sent",
    credits: "1 credit per 20 WhatsApp messages sent + Standard Meta charges",
  },
  { action: "Voice Agent", credits: "8 credits per minute" },
  // { action: "Anonymous Website Visitor", credits: "10 credits per lead" },
  // { action: "Post from Thought Leaders", credits: "20 credits per lead" },
  // { action: "Post from Target Company", credits: "20 credits per lead" },
  // {
  //   action: "Recent Job Changes",
  //   credits: "20 credits per lead x No. of times they change",
  // },
  // {
  //   action: "Person Mentioned in News",
  //   credits: "20 credits per news notification",
  // },
  // {
  //   action: "Company Mentioned in News",
  //   credits: "20 credits per news notification",
  // },
  // { action: "Job Posting by Company", credits: "20 credits per job posting" },
  // {
  //   action: "New Funding Announcement",
  //   credits: "20 credits per funding announcement",
  // },
  { action: "AI-Generated Email", credits: "2 credits per email" },
  {
    action: "Reasons to Engage",
    credits: "~2 credits per lead",
    tooltip:
      "Actionable triggers (based on real time activities, intent signals, external events) which help you reach out at the right time, with the right message",
  },
  { action: "Contact Market Research", credits: "~2 credits per lead" },
  { action: "Company Market Research", credits: "~2 credits per company" },
  { action: "Qualification Agent", credits: "~10 credits per lead" },
  {
    action: "Call Prep Summary",
    credits: "~1 credit per lead",
    tooltip:
      "Provides a concise, AI-generated overview of the most important information needed before a call (about contact/company, previous call outcomes, recent interactions, open tasks/tickets)",
  },
  // {
  //   action: "Meeting Agent",
  //   credits: "25 credits per meeting booked",
  //   tooltip: "Meetings booked via meeting agent, meeting router",
  // },
  // { action: "Workflow", credits: "1 credit per 5 executions" },
  // { action: "Process Design", credits: "1 credit per 5 executions" },
  // {
  //   action: "Sequence - Step Execution",
  //   credits: "1 credit per 5 steps executed",
  // },
  { action: "I-Assistant", credits: "~1 credit per message" },
  // { action: "Form Responses (Internal)", credits: "1 credit per 10 responses" },
  // {
  //   action: "Routing Form Responses (External)",
  //   credits: "1 credit per 10 responses",
  // },
  {
    action: "Customer Success - Alerts",
    credits: "10 credits per alert agent created",
  },
  {
    action: "Customer Support - Live Chat Widget",
    credits: "100 credits per conversation closed by AI",
  },
  { action: "AI Notetaker - Transcription", credits: "2 credits per minute" },
  {
    action: "Vibe Coder",
    credits: "Credits based on AI compute used per generation",
    tooltip:
      "Credits vary depending on the complexity of the AI task, length of input/output, and compute required",
  },
  {
    action: "AI Consumption",
    credits: "Credits based on AI compute used per request",
    tooltip:
      "Credits vary depending on the complexity of the AI task, length of input/output, and compute required (Cold Outreach (AI Usage), Sequences (Qualification Agent), Prospect (AI Search), Customer Success, AI Notetaker (Conversation Intelligence))",
  },
];
